// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-container[data-v-76e0bda9]{display:flex;align-items:center;justify-content:center;height:100vh}.login-container .login-centered[data-v-76e0bda9]{width:500px;max-width:100%}", ""]);
// Exports
module.exports = exports;
